module.exports = __webpack_public_path__ + "img/PSG.430be71a.png";